import axios from "../axios-auth";
import orginal_axios from "axios";

export const productionService = {
    getAllProductionStatus,
    getProductionList,
    getProductionDetail,
    saveProduction,
    getProductionExcelExport,
    printInvoice,
    showWindowDialog,
};

function getAllProductionStatus() {
    return axios.get("/auth/all-production-status");
}

function getProductionList(searchParams, page, size, sortedBy) {
    if (!page) {
        page = 0;
    } else {
        page -= 1;
    }

    if (!size) {
        size = 50;
    }

    let params = {
        page: page,
        size: size,
        sort: sortedBy,
    };

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.productionOrderNo) {
        params["productionOrderNo"] = searchParams.productionOrderNo;
    }
    if (searchParams.emrNo) {
        params["emrNo"] = searchParams.emrNo;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.productionItemId) {
        params["productionItemId"] = searchParams.productionItemId;
    }
    if (searchParams.productionItemDetailId) {
        params["productionItemDetailId"] = searchParams.productionItemDetailId;
    }
    if (searchParams.departmentId) {
        params["departmentId"] = searchParams.departmentId;
    }
    if (typeof (searchParams.isAddDetail) == 'boolean') {
        params["isAddDetail"] = searchParams.isAddDetail;
    }
    if (typeof (searchParams.isAddCostDetail) == 'boolean') {
        params["isAddCostDetail"] = searchParams.isAddCostDetail;
    }

    return axios.get("/auth/productions", { params });
}

function getProductionDetail(id, searchParams) {
    let params = {};
    if (searchParams.isAddDetail) {
        params["isAddDetail"] = searchParams.isAddDetail;
    }
    if (searchParams.isAddCostDetail) {
        params["isAddCostDetail"] = searchParams.isAddCostDetail;
    }

    return axios.get("/auth/production/" + id, { params });
}

function saveProduction(production) {
    if (!production.id) {
        //register
        return axios.post("/auth/production", production);
    } else {
        //update
        return axios.put("/auth/production", production);
    }
}

function getProductionExcelExport(searchParams) {
    let params = {};

    if (searchParams.fromDate) {
        params["fromDate"] = searchParams.fromDate;
    }
    if (searchParams.toDate) {
        params["toDate"] = searchParams.toDate;
    }
    if (searchParams.issueNo) {
        params["issueNo"] = searchParams.issueNo;
    }
    if (searchParams.shopId) {
        params["shopId"] = searchParams.shopId;
    }
    if (searchParams.name) {
        params["name"] = searchParams.name;
    }
    if (searchParams.productionOrderNo) {
        params["productionOrderNo"] = searchParams.productionOrderNo;
    }
    if (searchParams.emrNo) {
        params["emrNo"] = searchParams.emrNo;
    }
    if (searchParams.status) {
        params["status"] = searchParams.status;
    }
    if (searchParams.productionItemId) {
        params["productionItemId"] = searchParams.productionItemId;
    }
    if (searchParams.productionItemDetailId) {
        params["productionItemDetailId"] = searchParams.productionItemDetailId;
    }
    if (searchParams.departmentId) {
        params["departmentId"] = searchParams.departmentId;
    }
    if (typeof (searchParams.isAddDetail) == 'boolean') {
        params["isAddDetail"] = searchParams.isAddDetail;
    }
    if (typeof (searchParams.isAddCostDetail) == 'boolean') {
        params["isAddCostDetail"] = searchParams.isAddCostDetail;
    }

    return orginal_axios({
        method: "GET",
        url: axios.defaults.baseURL + "/auth/production-excel-export",
        params,
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        }
    }).then(function (response) {
        return { blob: new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }), headers: response.headers }
    });
}

function printInvoice(id) {
    return orginal_axios({
        url: axios.defaults.baseURL + "/auth/print-production-invoice/" + id,
        method: "GET",
        responseType: "arraybuffer", // important
        headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken"),
            Accept: "application/pdf",
            "Content-Type": "application/json"
        }
    }).then(function (response) {
        return new Blob([response.data], { type: "application/pdf" });
    });
}

function showWindowDialog(blob, fileName) {
    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob);
        return;
    }

    // For other browsers: 
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(blob);
    var link = document.createElement(fileName);
    link.href = data;
    link.download = fileName + ".pdf";
    window.open(link.href, fileName, "width=500,height=500");

    setTimeout(function () {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
    }, 100);
}